import { useState } from "react";
import { Button } from "@mui/material";
import "./FetchHistory.css";
import { CloudDownload as CloudDownloadIcon } from "@mui/icons-material";
import { fetchAuthSession } from "aws-amplify/auth";

const FetchHistory = ({ prefix, currentPlan, setSection }) => {
  const [presignedUrls, setPresignedUrls] = useState(null);
  const [resultsLoading, setResultsLoading] = useState(false);
  const [calculatedTaxYear, setCalculatedTaxYear] = useState(null);

  const checkResults = async () => {
    setResultsLoading(true);
    const session = await fetchAuthSession();
    const token = session.tokens.idToken.toString();
    const response = await fetch(
      `${
        process.env.REACT_APP_API_URL
      }/checkForResults?folder=${encodeURIComponent(prefix)}`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    ); // API endpoint that checks S3
    const data = await response.json();

    if (data.message) {
      alert("Error fetching results, please try again later");
      setResultsLoading(false);
    } else if (!data.message) {
      const { metadata, ...results } = data;
      setPresignedUrls(results);
      setResultsLoading(false);
      setCalculatedTaxYear(metadata["tax_year"]);
    }
  };

  function parseUTCTimestamp(timestamp) {
    const year = timestamp.substring(0, 4);
    const month = timestamp.substring(4, 6) - 1; // JS months are 0-based
    const day = timestamp.substring(6, 8);
    const hour = timestamp.substring(8, 10);
    const minute = timestamp.substring(10, 12);
    const second = timestamp.substring(12, 14);
    const millisecond = timestamp.substring(14, 17);

    // Create a Date object in UTC
    return new Date(
      Date.UTC(year, month, day, hour, minute, second, millisecond)
    );
  }

  function formatDateToUserTimezone(date) {
    return date
      .toLocaleString("en-US", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: false,
        timeZoneName: "short",
      })
      .replace(",", "");
  }

  const renderDownloadButtons = () => {
    const files = [
      // { name: "main_report.csv", url: presignedUrls.main_report_file },
      // { name: "income_report.csv", url: presignedUrls.income_file },
      // {
      //   name: "capital_gains_report.csv",
      //   url: presignedUrls.capital_gains_file,
      // },
      // {
      //   name: "form_8949.pdf",
      //   url: presignedUrls.form_8949,
      // },
      {
        name: `Coin_Basis_crypto_tax_forms_${calculatedTaxYear}.zip`,
        url: presignedUrls.tax_report_zip,
      },
    ];

    return (
      <div className="history-download-section">
        {files.map((file) =>
          file.url ? (
            <Button
              key={file.name}
              className="history-download-button"
              startIcon={<CloudDownloadIcon />}
              onClick={() => (window.location.href = file.url)}
            >
              {file.name}
            </Button>
          ) : (
            <Button
              key={file.name}
              className="history-download-button"
              onClick={alert(
                "Please contact support for help recovering lost data"
              )}
            >
              Could Not Find History
            </Button>
          )
        )}
      </div>
    );
  };

  const timestamp = prefix.split("/")[2].split("_")[0]; // Extract timestamp from key
  const readableDate = formatDateToUserTimezone(parseUTCTimestamp(timestamp));

  return (
    <tr key={prefix}>
      <td>{readableDate}</td>
      {presignedUrls ? (
        renderDownloadButtons()
      ) : (
        <td>
          {currentPlan === "Pro" ? (
            <Button
              onClick={checkResults}
              variant="contained"
              color="primary"
              disabled={resultsLoading}
            >
              {resultsLoading ? "Loading..." : "Retrieve Result Links"}
            </Button>
          ) : (
            <Button
              onClick={() => setSection("membership")}
              variant="contained"
              color="primary"
            >
              Upgrade to Pro to recover
            </Button>
          )}
        </td>
      )}
    </tr>
  );
};

export default FetchHistory;
